export const primeStyles = {
	header: {
		backgroundColor: '#ddf0f6',
	},
	sidebar: {
		backgroundColor: '#00468b',
		color: 'white',
	},
	button: {
		backgroundColor: '#e06538',
		color: '#FFFFFF',
		border: '1px solid #00468b',
		fontWeight: 600,
		':hover': {
			color: '#ffffff',
			backgroundColor: '#a84c2a',
			borderColor: '#a84c2a',
		},
	},
	title: {
		color: 'black',
	},
	text: {
		color: '#00468b',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#00468b',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Prime Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/prime/prime-icon-white.svg',
			height: 55,
			width: 55,
		},
		large: {
			src: '/prime/prime-logo-white.svg',
			height: 45,
			width: 165,
		},
	},
	favicon: {
		src: '/prime/prime-icon-white.svg',
	},
	socials: {},
	siteUrl: 'https://parkwithprime.com/',
	orgName: 'Prime Parking',
};
